import { useCallback } from 'react';
import useHandleAppException, { AppExceptionResponse } from '../../../hooks/useHandleAppException';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../translation/TranslationContext';

const useOAuthErrorMessage = () => {
  const { handleErrorResponse } = useHandleAppException();
  const { translate } = useTranslation();

  return useCallback(
    (response: unknown) => {
      const exceptionResponse = response as AppExceptionResponse;
      return (
        (exceptionResponse.data ? handleErrorResponse(exceptionResponse) : undefined) ||
        translate(LangEnum.SNACKBAR_ERROR_OCCURRED_TRY_AGAIN)
      );
    },
    [handleErrorResponse, translate],
  );
};

export default useOAuthErrorMessage;
